import React from "react";
export const MenuH = (props) => {
    var _a;
    const color = (_a = props.color) !== null && _a !== void 0 ? _a : "#5E6C84";
    return (React.createElement("svg", Object.assign({ width: props.size, height: props.size, fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: color, fillRule: "evenodd", d: "M2.25 6.5A.75.75 0 0 1 3 5.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75M2.25 12.5a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75M2.25 18a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75", clipRule: "evenodd" })));
};
//# sourceMappingURL=MenuH.js.map